<template>
  <el-dialog
    custom-class="App-User-Profile-Modal"
    :model-value="isModalOpen"
    width="550px"
    :show-close="showClose"
    @open="opened"
    title="Profile Picture"
    center
    :close-on-click-modal="showClose"
    :append-to-body="true"
    :lock-scroll="true"
    :open-delay="200"
    :close-delay="200"
    :before-close="closeModal"
    :close-on-press-escape="false"
  >
    <!--  -->
    <div v-loading="loading">
      <div txt-center>
        <p m-t-0 m-rl-auto style="max-width: 350px">
          Upload a file by clicking or drag-and-drop
          <br />
          <b> Max Size: 3MB (Megabytes) </b>
        </p>
      </div>
      <el-form
        @submit.prevent
        class="App-Styled-Form"
        :label-position="'top'"
        label-width="100px"
      >
        <div>
          <!--  -->
          <el-upload
            ref="upload"
            v-show="avatar === ''"
            m-rl-auto
            txt-center
            list-type="picture-card"
            :auto-upload="false"
            :on-remove="handleRemove"
            :on-change="handleAdd"
            :multiple="false"
            drag
          >
            <el-icon f-w-800><Plus /></el-icon>
          </el-upload>
          <!--  -->
          <div
            v-if="avatar !== ''"
            style="border-radius: 6px; overflow: hidden"
          >
            <cropper
              class="cropper"
              :src="avatar"
              :stencil-props="{
                aspectRatio: 1 / 1,
              }"
              @ready="finishedLoadingCropper"
              ref="cropper"
            />
          </div>
        </div>
      </el-form>
    </div>
    <!--  -->
    <template #footer>
      <div txt-center>
        <el-space fill w-100 :size="12" direction="vertical">
          <el-button
            is-block
            icon="el-icon-refresh"
            @click="handleRemove"
            type="default"
            :disabled="loading"
            plain
            is-all-borderless
            v-if="avatar !== ''"
          >
            Change Image
          </el-button>
          <el-button
            is-block
            icon="el-icon-check"
            @click="submit"
            size="large"
            type="primary"
            :disabled="loading"
          >
            Save
          </el-button>
        </el-space>
      </div>
    </template>
    <!--  -->
  </el-dialog>
</template>

<script lang="ts">
import { ErrorUtil } from "@/shared/classes";
import { User } from "@/shared/interfaces";
import { AccountUtil } from "@/shared/vuex";
import { Options, Vue } from "vue-class-component";
import { Emit, Watch } from "vue-property-decorator";
//
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { Plus } from "@element-plus/icons";

@Options({
  components: {
    Cropper,
    Plus,
  },
})
export default class extends Vue {
  /**
   * Modal variables
   */
  loading = false;
  isModalOpen = false; // false
  showClose = false;
  /**
   * Crop data
   */
  avatar = "";

  /**
   * @when the modal is checked
   */
  @Emit("checked")
  async mounted() {
    console.log("Mounted with ", this.$store.state.account);
    this.isModalOpen = this.$store.state.account.user?.avatar === undefined;
  }

  /**
   * @when the cropper is ready
   */
  finishedLoadingCropper() {
    this.loading = false;
  }

  /**
   * @param file
   */
  handleAdd(file) {
    console.log("File Added ", file);
    this.avatar = file.url;
  }

  /**
   * @param file
   */
  handleRemove() {
    (this.$refs as any).upload.clearFiles();
    this.avatar = "";
  }

  /**
   * @submits image only
   */
  submitImage() {
    const { canvas } = (this.$refs as any).cropper.getResult();
    return new Promise((resolve, reject) => {
      if (canvas) {
        const form = new FormData();
        return canvas.toBlob((blob) => {
          form.append("file", blob);
          // You can use axios, superagent and other libraries instead here
          resolve(this.$api.main.put<User>("/v1/account/avatars", form));
          // Perhaps you should add the setting appropriate file format here
        }, "image/jpeg");
      } else reject(new Error("Something went wrong."));
    });
  }
  /**
   * @saves the changes of made on the user profile
   */
  submit() {
    this.loading = true;
    this.submitImage()
      .then((resp) => {
        AccountUtil.fetchCurrent(this.$store).finally(
          () => (this.loading = false)
        );
        this.closeModal();
      })
      .catch((err) => {
        this.$message({
          duration: ErrorUtil.duration,
          type: "error",
          message: ErrorUtil.stringify(err),
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /**
   * Close modal
   */
  @Emit("closed")
  closeModal() {
    console.log("Clicked close the modal");
    this.$store.commit("modals/avatar", false); // This is enough itself
    this.isModalOpen = false;
  }

  /**
   * @Watch for open trigger
   * if triggered the user should be able to add education
   */
  @Watch("$store.state.modals.avatar")
  watchForOpen() {
    this.isModalOpen = this.$store.state.modals.avatar;
    console.log("Should open the upload");
    if (this.isModalOpen) this.showClose = true;
  }
  /**
   *
   */
  @Emit("opened")
  opened() {
    console;
  }
}
</script>

<style lang="scss">
.App-User-Profile-Modal {
  .App-Styled-Form {
    max-width: 400px;
    margin: auto;
  }
}
.el-upload--picture-card {
  width: 348px !important;
  height: 348px !important;
  line-height: 346px !important;
}
</style>
